import React from 'react';

const CheckIcon = (props) => (
  <svg
    width="21"
    height="19"
    viewBox="0 0 21 19"
    data-type="fill"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.494 1.31671L6.56066 12.8334L3.39399 9.45004C2.81066 8.90004 1.89399 8.86671 1.22732 9.33338C0.577323 9.81671 0.393989 10.6667 0.793989 11.35L4.54399 17.45C4.91066 18.0167 5.54399 18.3667 6.26066 18.3667C6.94399 18.3667 7.59399 18.0167 7.96066 17.45C8.29399 16.9167 19.044 3.86671 19.044 3.86671C19.3773 3.41671 19.494 2.88338 19.344 2.38338C19.1939 1.88338 18.8213 1.43338 18.344 1.23338C17.8667 1.03338 17.3439 1.15004 16.9119 1.53338L18.494 1.31671Z"
    />
  </svg>
);

export default CheckIcon;
